export const asMediaObjectOutlineIcon = {
  data: `
    <svg class="border border-gray-200 dark:border-gray-600 bg-transparent text-gray-200 dark:text-gray-600" preserveAspectRatio="none" stroke="currentColor" fill="none" viewBox="0 0 200 200" aria-hidden="true">
      <path vector-effect="non-scaling-stroke" stroke-width="1" d="M0 0l200 200M0 200L200 0" />
    </svg>`,
  name: 'outline/media-object'
};
